import { Header, Text, VStack } from '@rbilabs/universal-components';

export const Container = VStack.withConfig({
  width: 'full',
  alignItems: 'center',
  marginTop: {
    base: '50%',
    md: '5%',
  },
  marginBottom: {
    md: '8',
  },
});

export const Title = Header.withConfig({
  textTransform: 'capitalize',
  margin: 0,
});

export const StyledText = Text.withConfig({
  margin: 0,
  textAlign: 'center',
});

export const ButtonContainer = VStack.withConfig({
  alignItems: 'center',
  marginTop: '4',
  width: {
    base: '80%',
    md: '300px',
  },
});
